import React from "react";
import SpecsListItem from "../SpecsListItem/SpecsListItem";
import "./SpecsList.sass";

const renderListItem = (item, index) => {
  if (item.key !== "logo url") {
    return <SpecsListItem name={item.key} value={item.value} />;
  }
};

const SpecsList = ({ data }) => {
  return <div className="specs-list">{data.map(renderListItem)}</div>;
};

export default SpecsList;
